export default __webpack_public_path__ + "static/media/P-023.c7e31c02.png";